function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGenericBankAccount = function SvgGenericBankAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8b9c8f"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.555 11.37a1 1 0 0 0-1.109 0l-5.193 3.462a1 1 0 0 1-.556.168H12v2h1a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-1v2h16v-2h-1a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h1v-2h-1.697a1 1 0 0 1-.555-.168l-5.193-3.462zM24 18a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-6zm-6-1a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#e7ece9"
    }
  }));
};
export default SvgGenericBankAccount;